module.exports = __webpack_public_path__ + "static/media/home5.ceb26588.png";